import axios from 'axios'

const http = axios.create({
  withCredentials: true,
  baseURL: process.env.BACKEND_HOST,
  timeout: 15000
})

export default http



// WEBPACK FOOTER //
// ./src/modules/Http.js